import LegalLayout, { LegalSection } from "@/components/LegalLayout";
import { BRAND } from "@/lib/products";

export default function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="July 2026">
      <LegalSection>
        <p>
          These Terms of Service (&ldquo;Terms&rdquo;) govern your use of the{" "}
          {BRAND.name} website ({BRAND.website}) and services, operated by{" "}
          <strong>{BRAND.legalName}</strong>. By accessing or using our website
          or services, you agree to be bound by these Terms. If you do not agree,
          please do not use the website.
        </p>
      </LegalSection>

      <LegalSection heading="About Our Services">
        <p>
          {BRAND.name}, operated by {BRAND.legalName}, provides general insurance
          information and facilitation services, helping individuals and
          businesses compare and choose insurance products offered by
          IRDAI-licensed insurers. We act as an intermediary between you and the
          insurance companies; the insurance contract is issued by, and is the
          responsibility of, the respective insurer.
        </p>
      </LegalSection>

      <LegalSection heading="Use of the Website">
        <ul className="list-disc pl-6 space-y-2">
          <li>
            You agree to provide accurate and complete information when
            requesting quotes or services.
          </li>
          <li>
            You will not use the website for any unlawful, fraudulent, or harmful
            purpose.
          </li>
          <li>
            You will not attempt to disrupt, damage, or gain unauthorised access
            to the website or its systems.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="No Guarantee of Coverage">
        <p>
          Quotes, premiums, and product information displayed or shared are
          indicative and subject to change, underwriting, and final acceptance by
          the insurer. Issuance of any policy is at the sole discretion of the
          relevant insurance company. Nothing on this website constitutes a
          binding offer of insurance.
        </p>
      </LegalSection>

      <LegalSection heading="Third-Party Insurers and Links">
        <p>
          Policies are provided by third-party insurers governed by their own
          terms, conditions, and policy documents. We are not responsible for the
          acts, omissions, coverage decisions, or claim settlements of any
          insurer. Please read the insurer&rsquo;s policy wording carefully
          before purchasing.
        </p>
      </LegalSection>

      <LegalSection heading="Intellectual Property">
        <p>
          The content, logo, brand name, design, and materials on this website
          are the property of {BRAND.legalName} and may not be copied,
          reproduced, or used without our prior written permission.
        </p>
      </LegalSection>

      <LegalSection heading="Limitation of Liability">
        <p>
          To the maximum extent permitted by law, {BRAND.legalName} shall not be
          liable for any indirect, incidental, or consequential loss arising from
          your use of the website or reliance on any information provided. Our
          role is limited to facilitating your access to insurance products.
        </p>
      </LegalSection>

      <LegalSection heading="Governing Law">
        <p>
          These Terms are governed by the laws of India. Any disputes shall be
          subject to the exclusive jurisdiction of the competent courts in India.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to These Terms">
        <p>
          We may update these Terms from time to time. Continued use of the
          website after changes are posted constitutes your acceptance of the
          revised Terms.
        </p>
      </LegalSection>

      <LegalSection heading="Contact Us">
        <p>For any questions about these Terms, please contact:</p>
        <ul className="list-none space-y-1">
          <li>
            <strong>{BRAND.legalName}</strong> ({BRAND.name})
          </li>
          <li>
            Email:{" "}
            <a
              href={`mailto:${BRAND.email}`}
              className="text-[#1e3a8a] hover:underline"
            >
              {BRAND.email}
            </a>
          </li>
          {BRAND.phones.map((p) => (
            <li key={p}>
              Phone:{" "}
              <a
                href={`tel:+91${p}`}
                className="text-[#1e3a8a] hover:underline"
              >
                +91 {p}
              </a>
            </li>
          ))}
        </ul>
      </LegalSection>
    </LegalLayout>
  );
}
